import React from 'react';
import { FaExclamationTriangle, FaCheckCircle, FaClock, FaWhatsapp, FaCamera, FaFileInvoiceDollar, FaEnvelope } from 'react-icons/fa';
import './RefundPolicy.css';

const RefundPolicy = () => {
  const policySections = [
    {
      title: "Important Notice",
      content: "The customer must check the size charts and colors before confirming the order.",
      icon: <FaExclamationTriangle />,
      type: "warning"
    },
    {
      title: "Modification Policy",
      content: "Clothes modification and change size or color not have a replacement policy.",
      icon: <FaExclamationTriangle />,
      type: "warning"
    },
    {
      title: "Replacement Conditions",
      content: "It can only be replaced in certain cases:",
      icon: <FaCheckCircle />,
      type: "info",
      list: [
        "The product has a defect.",
        "An mistake by the store or the product Different than the customer has specified."
      ]
    }
  ];

  const exchangeSteps = [
    {
      step: "1",
      title: "Notify Within 48 Hours",
      description: "The customer must inform the store within 48 hours of receiving the product.",
      icon: <FaClock />
    },
    {
      step: "2",
      title: "Contact via WhatsApp",
      description: "Customer contacte the store by WhatsApp and sent a picture of the product and clarified the defect, and clear picture of the invoice.",
      icon: <FaWhatsapp />
    },
    {
      step: "3",
      title: "Store Verification",
      description: "The store will check the defect and determines replacement will make or not.",
      icon: <FaCheckCircle />
    },
    {
      step: "4",
      title: "Exchange Process",
      description: "After the product arrives at the store and confirmed that there is a defect, it will be exchanged within 5 days from the date of receiving.",
      icon: <FaFileInvoiceDollar />
    }
  ];

  return (
    <div className="refund-policy-page">
      <div className="container">
        {/* Page Header */}
        <div className="page-header">
          <h1 className="page-title">Return and Exchange Policy</h1>
          <p className="page-subtitle">Understanding our return and exchange procedures</p>
        </div>

        <div className="policy-content">
          {/* Policy Sections */}
          <div className="policy-sections">
            {policySections.map((section, index) => (
              <div key={index} className={`policy-section ${section.type}`}>
                <div className="section-header">
                  <div className="section-icon">
                    {section.icon}
                  </div>
                  <h2 className="section-title">{section.title}</h2>
                </div>
                <div className="section-content">
                  <p className="section-text">{section.content}</p>
                  {section.list && (
                    <ul className="section-list">
                      {section.list.map((item, itemIndex) => (
                        <li key={itemIndex} className="list-item">{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Exchange Process */}
          <div className="exchange-process">
            <h2 className="process-title">How to Exchange</h2>
            <div className="steps-grid">
              {exchangeSteps.map((step, index) => (
                <div key={index} className="step-card">
                  <div className="step-number">{step.step}</div>
                  <div className="step-icon">
                    {step.icon}
                  </div>
                  <h3 className="step-title">{step.title}</h3>
                  <p className="step-description">{step.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Information */}
          <div className="contact-section">
            <h2 className="contact-title">Need Help?</h2>
            <p className="contact-description">
              If you have any questions about our return and exchange policy, 
              please don't hesitate to contact us via WhatsApp or email.
            </p>
            <div className="contact-methods">
              <div className="contact-method">
                <FaWhatsapp className="contact-icon" />
                <span>WhatsApp: 0501231234</span>
              </div>
              <div className="contact-method">
                <FaEnvelope className="contact-icon" />
                <span>Email: info@byeilir.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
